module.exports = __webpack_public_path__ + "static/img/greeno-sad-menu.62dedc9.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/hellocode-v2/greeno-sad-menu.svg
// module id = 99Lk
// module chunks = 4